// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1cHqD","title":"Info_title__3jvuL","selects":"Info_selects__lPE-h","requiredAsterisk":"Info_requiredAsterisk__19pwV"};